/**
 * Taken from this SO post: https://stackoverflow.com/a/55266531
 * This ensures that the array contains ALL values of a type. Example is below:
 *
 * type Furniture = 'chair' | 'table' | 'lamp' | 'ottoman';
 *
 *  type AtLeastOne<T> = [T, ...T[]];
 *
 *  const exhaustiveStringTuple = <T extends string>() =>
 *    <L extends AtLeastOne<T>>(
 *      ...x: L extends any ? (
 *        Exclude<T, L[number]> extends never ?
 *        L :
 *        Exclude<T, L[number]>[]
 *      ) : never
 *    ) => x;
 *
 *  const missingFurniture = exhaustiveStringTuple<Furniture>()('chair', 'table', 'lamp');
 *  // error, Argument of type '"chair"' is not assignable to parameter of type '"ottoman"'
 *
 *  const extraFurniture = exhaustiveStringTuple<Furniture>()(
 *    'chair', 'table', 'lamp', 'ottoman', 'bidet');
 *  // error, "bidet" is not assignable to a parameter of type 'Furniture'
 *
 *  const furniture = exhaustiveStringTuple<Furniture>()('chair', 'table', 'lamp', 'ottoman');
 *  // okay
 *
 */

type AtLeastOne<T> = [T, ...T[]];

export const exhaustiveStringTuple =
  <T extends string>() =>
  <L extends AtLeastOne<T>>(
    ...x: L extends any ? (Exclude<T, L[number]> extends never ? L : Exclude<T, L[number]>[]) : never
  ) =>
    x;
